import { useAuth } from '../contexts/AuthContext';

/**
 * Hook para verificar permissões do usuário atual.
 * @returns {{ can: function(section, level): boolean, canView, canEdit }}
 */
export const usePermissions = () => {
  const { user } = useAuth();
  const role = user?.role;
  const perms = user?.permissions || {};

  const can = (section, level = 'view') => {
    if (role === 'admin' || role === 'super_admin') return true;
    const userLevel = perms[section] || 'none';
    const order = { none: 0, view: 1, edit: 2 };
    return (order[userLevel] || 0) >= (order[level] || 0);
  };

  return {
    can,
    canView: (section) => can(section, 'view'),
    canEdit: (section) => can(section, 'edit'),
  };
};
